import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "../store";
import _ from 'lodash';
import clientLog from "@/helpers/clientLog";
import Landing from "../views/Landing";
import Home from '../views/Home.vue';
import OnlineServices from "../views/OnlineServices";
import OnlineServicesHome from "../views/OnlineServicesHome";
import OnlineServiceDetail from "../views/OnlineServiceDetail";
import OnlineServicePensionCalculator from '../views/OnlineServicePensionCalculator';
import Documents from "../views/Documents";
import DocumentCategory from "../views/DocumentCategory";
import DocumentsHome from "../views/DocumentsHome";
import DocumentsAll from "../views/DocumentsAll";
import Products from "../views/Products";
import ProductsHome from "../views/ProductsHome";
import ProductDetail from "../views/ProductDetail";
import Articles from "../views/Articles";
import ArticlesHome from "../views/ArticlesHome";
import ArticleDetail from "../views/ArticleDetail";
import Contacts from "../views/Contacts";
import Cards from "../views/Cards";
import Profile from "../views/Profile";
import PageNotFound from "../views/PageNotFound";
import BranchDetail from "../views/BranchDetail";
import PartnerDetail from "../views/PartnerDetail";
import MobilityDetail from "../views/MobilityDetail";
import PageDetail from "../views/PageDetail";
import Investments from "@/views/Investments";
import InvestmentsHome from "@/views/InvestmentsHome";
import InvestmentsEic from "@/views/InvestmentsEic";
import InvestmentsEicAccount from "@/views/InvestmentsEicAccount";
import InvestmentsIad from "@/views/InvestmentsIad";
import InvestmentsIadAccount from "@/views/InvestmentsIadAccount";
import InvestmentsConseq from "@/views/InvestmentsConseq";
import InvestmentsConseqAccount from "@/views/InvestmentsConseqAccount";
import InvestmentsInvestika from "@/views/InvestmentsInvestika";
import InvestmentsInvestikaAccount from "@/views/InvestmentsInvestikaAccount";
import InvestmentsGutmann from "@/views/InvestmentsGutmann";
import InvestmentsGutmannAccount from "@/views/InvestmentsGutmannAccount";
import InvestmentsSympatia from "@/views/InvestmentsSympatia";
import InvestmentsSympatiaAccount from "@/views/InvestmentsSympatiaAccount";
import InvestmentsKoop from "@/views/InvestmentsKoop";
import InvestmentsKoopAccount from "@/views/InvestmentsKoopAccount";
import Properties from "@/views/Properties";
import Debts from "@/views/Debts";
import Payments from "@/views/Payments";
import Receipts from "@/views/Receipts";
import EmailVerification from "@/views/EmailVerification.vue";
import i18n from "../i18n";
import { trackEvent } from "../analytics";
import { App } from '@capacitor/app';

import { SplashScreen } from "@capacitor/splash-screen";

Vue.use(VueRouter)

const routes = [
	{
		path: i18n.t('routes.landing.path'),
		name: 'Landing',
		component: Landing,
		meta: {
			public: true
		}
	},
	{
		path: i18n.t('routes.home.path'),
		name: 'Home',
		component: Home
	},
	{
		path: '/verify-email/:userId/:hash',
		name: 'EmailVerification',
		component: EmailVerification,
		meta: {
			public: true
		}
	},
	{
		path: i18n.t('routes.online_services.path'),
		component: OnlineServices,
		children: [
			{
				path: '',
				name: 'OnlineServicesHome',
				component: OnlineServicesHome
			},
			{
				path: `${i18n.t('routes.mobility.sub_path')}/:id`,
				name: 'MobilityDetail',
				component: MobilityDetail
			},
			{
				path: 'pension-calculator',
				name: 'OnlineServicePensionCalculator',
				component: OnlineServicePensionCalculator
			},
			{
				path: ':slug',
				name: 'OnlineServiceDetail',
				component: OnlineServiceDetail
			},
		]
	},
	{
		path: i18n.t('routes.documents.path'),
		component: Documents,
		children: [
			{
				path: '',
				name: 'DocumentsHome',
				component: DocumentsHome
			},
			{
				path: i18n.t('routes.all_documents.sub_path'),
				name: 'DocumentsAll',
				component: DocumentsAll,
			},
			{
				path: ':category',
				name: 'DocumentCategory',
				component: DocumentCategory,
			},
		]
	},
	{
		path: i18n.t('routes.products.path'),
		component: Products,
		children: [
			{
				path: '',
				name: 'ProductsHome',
				component: ProductsHome
			},
			{
				path: ':id',
				name: 'ProductDetail',
				component: ProductDetail,
			},
		]
	},
	{
		path: i18n.t('routes.articles.path'),
		component: Articles,
		children: [
			{
				path: '',
				name: 'ArticlesHome',
				component: ArticlesHome
			},
			{
				path: ':id',
				name: 'ArticleDetail',
				component: ArticleDetail,
			},
		]
	},
	{
		path: i18n.t('routes.contacts.path'),
		name: 'Contacts',
		component: Contacts
	},
	{
		path: `${i18n.t('routes.branch.path')}/:id`,
		name: 'BranchDetail',
		component: BranchDetail
	},
	{
		path: `${i18n.t('routes.partner.path')}/:id`,
		name: 'PartnerDetail',
		component: PartnerDetail
	},
	{
		path: i18n.t('routes.cards.path'),
		name: 'Cards',
		component: Cards
	},
	{
		path: i18n.t('routes.investments.path'),
		name: 'Investments',
		component: Investments,
		children: [
			{
				path: '',
				name: 'InvestmentsHome',
				component: InvestmentsHome
			},
			{
				path: i18n.t('routes.investments_eic.sub_path'),
				name: 'InvestmentsEic',
				component: InvestmentsEic
			},
			{
				path:  `${i18n.t('routes.investments_eic.sub_path')}/:id`,
				name: 'InvestmentsEicAccount',
				component: InvestmentsEicAccount
			},
			{
				path: i18n.t('routes.investments_iad.sub_path'),
				name: 'InvestmentsIad',
				component: InvestmentsIad
			},
			{
				path:  `${i18n.t('routes.investments_iad.sub_path')}/:slug`,
				name: 'InvestmentsIadAccount',
				component: InvestmentsIadAccount
			},
			{
				path: i18n.t('routes.investments_conseq.sub_path'),
				name: 'InvestmentsConseq',
				component: InvestmentsConseq
			},
			{
				path:  `${i18n.t('routes.investments_conseq.sub_path')}/:id`,
				name: 'InvestmentsConseqAccount',
				component: InvestmentsConseqAccount
			},
			{
				path: i18n.t('routes.investments_investika.sub_path'),
				name: 'InvestmentsInvestika',
				component: InvestmentsInvestika
			},
			{
				path:  `${i18n.t('routes.investments_investika.sub_path')}/:id`,
				name: 'InvestmentsInvestikaAccount',
				component: InvestmentsInvestikaAccount
			},
			{
				path: i18n.t('routes.investments_koop.sub_path'),
				name: 'InvestmentsKoop',
				component: InvestmentsKoop
			},
			{
				path: `${i18n.t('routes.investments_koop.sub_path')}/:id`,
				name: 'InvestmentsKoopAccount',
				component: InvestmentsKoopAccount
			},
			{
				path: i18n.t('routes.investments_gutmann.sub_path'),
				name: 'InvestmentsGutmann',
				component: InvestmentsGutmann
			},
			{
				path: `${i18n.t('routes.investments_gutmann.sub_path')}/:id`,
				name: 'InvestmentsGutmannAccount',
				component: InvestmentsGutmannAccount
			},
			{
				path: i18n.t('routes.investments_sympatia.sub_path'),
				name: 'InvestmentsSympatia',
				component: InvestmentsSympatia
			},
			{
				path: `${i18n.t('routes.investments_sympatia.sub_path')}/:id`,
				name: 'InvestmentsSympatiaAccount',
				component: InvestmentsSympatiaAccount
			},
		]
	},
	{
		path: i18n.t('routes.properties.path'),
		name: 'Properties',
		component: Properties,
	},
	{
		path: i18n.t('routes.debts.path'),
		name: 'Debts',
		component: Debts,
	},
	{
		path: i18n.t('routes.profile.path'),
		name: 'Profile',
		component: Profile
	},
	{
		path: i18n.t('routes.payments.path'),
		name: 'Payments',
		component: Payments
	},
	{
		path: i18n.t('routes.receipts.path'),
		name: 'Receipts',
		component: Receipts
	},
	{
		path: '/404',
		name: 'PageNotFound',
		component: PageNotFound,
	},
	{
		path: '/:slug',
		name: 'PageDetail',
		component: PageDetail,
		meta: {
			public: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior() {
		return { x: 0, y: 0 };
	}
});

export function loadRouteData(route) {
	switch (route.name) {
		case 'Home':
		case 'OnlineServicesHome':
			return store.dispatch('getDashboardData');
		case 'DocumentsAll':
		case 'DocumentsHome':
			return store.dispatch('getDocumentsData');
		case 'ProductsHome':
			return store.dispatch('getProductsData');
		case 'ArticlesHome':
			return store.dispatch('getArticlesData');
		case 'ProductDetail':
			return store.dispatch('getProductData', route.params.id);
		case 'ArticleDetail':
			return store.dispatch('getArticleData', route.params.id);
		case 'OnlineServiceDetail':
			clientLog.info('entering OnlineServiceDetail', { slug: route.params.slug }, 'router');
			return store.dispatch('getOnlineServiceData', route.params.slug);
		case 'DocumentCategory':
			return store.dispatch('getDocumentCategoryData', route.params.category);
		case 'Cards':
			return store.dispatch('getCardsData');
		case 'MobilityDetail':
			return store.dispatch('getMobilityData', route.params.id);
		case 'InvestmentsHome':
		case 'InvestmentsEic':
		case 'InvestmentsIad':
		case 'InvestmentsConseq':
		case 'InvestmentsInvestika':
		case 'InvestmentsGutmann':
		case 'InvestmentsSympatia':
		case 'InvestmentsKoop':
			return store.dispatch('getInvestmentsData');
		case 'InvestmentsEicAccount':
			return store.dispatch('getInvestmentsEicAccountData', route.params.id);
		case 'InvestmentsIadAccount':
			return store.dispatch('getInvestmentsIadAccountData', route.params.slug);
		case 'InvestmentsConseqAccount':
			return store.dispatch('getInvestmentsConseqAccountData', route.params.id);
		case 'InvestmentsInvestikaAccount':
			return store.dispatch('getInvestmentsInvestikaAccountData', route.params.id);
		case 'InvestmentsGutmannAccount':
			return store.dispatch('getInvestmentsGutmannAccountData', route.params.id);
		case 'InvestmentsSympatiaAccount':
			return store.dispatch('getInvestmentsSympatiaAccountData', route.params.id);
		case 'InvestmentsKoopAccount':
			return store.dispatch('getInvestmentsKoopAccountData', route.params.id);
		case 'Contacts':
		case 'BranchDetail':
		case 'PartnerDetail':
			return store.dispatch('getContactsData');
		case 'PageDetail':
			return store.dispatch('getPageData', route.params.slug);
		case 'Properties':
			return store.dispatch('getPropertiesData');
		case 'Debts':
			return store.dispatch('getDebtsData');
		case 'Payments':
			return store.dispatch('getPaymentsData');
		case 'Receipts':
			return store.dispatch('getReceiptsData');
		case 'Profile':
			return store.dispatch('getProfileData');
		default:
			return Promise.resolve();
	}
}

function nextFactory(to, from, next) {
	let fromPublic = false;
	if (to.name === 'Home' && from.meta.public) {
		fromPublic = true;
	}

	if (!fromPublic) {
		store.commit('SET_APP_LAYOUT', !to.meta.public);
	}

	loadRouteData(to).then(() => {
		if (fromPublic) {
			store.commit('SET_APP_LAYOUT', !to.meta.public);
		}

		if (to.name === 'BranchDetail') {
			let branch = store.state.views.branches.find(item => {
				return item.id_satelit === to.params.id;
			});

			if (!branch) {
				router.push('/404');
				return false;
			}
		}

		if (to.name === 'PartnerDetail') {
			let partner = store.state.views.partners.find(item => {
				return item.code === to.params.id;
			});

			if (!partner) {
				router.push('/404');
				return false;
			}
		}

		next();
	});
}

router.beforeEach((to, from, next) => {
	//Auth Middleware
	if (to.meta.public) {
		nextFactory(to, from, next);
		return true;
	}

	if (store.state.auth.isLoggedIn && !_.isEmpty(store.state.auth.user)) {
		nextFactory(to, from, next);
	} else {
		store.dispatch('getUser').then(() => {
			nextFactory(to, from, next);
		}).catch(() => {
			if (from.name === 'Landing') {
				return false;
			}
			router.push(i18n.t('routes.landing.path'));
		});
	}
});

const ANALYTICS_EXCLUDED_ROUTES = ['EmailVerification', 'OnlineServicePensionCalculator']

router.afterEach((to) => {
	if (store.state.app.native) {
		SplashScreen.hide();
	}
	store.commit('UNSET_SHOW_NAV');

	if (to.name === 'Home' && store.state.auth.pendingAction && store.state.auth.user.active) {
		store.dispatch('processPendingAction', store.state.auth.pendingAction);
	}

	if (to.name && !ANALYTICS_EXCLUDED_ROUTES.includes(to.name)) {
		trackEvent('page_view', {
			page_name: to.name,
			page_path: to.matched[0] ? to.matched[0].path : to.path,
		})
	}
});

router.previousRoute = null
router.beforeEach((to, from, next) => {
	router.previousRoute = from.name ? { name: from.name, params: from.params, query: from.query } : null
	next()
})

router.safeBack = ()=> {
	if (router.previousRoute) {
		router.push(router.previousRoute)
	} else {
		router.replace({ name: 'Home' })
	}
}

App.addListener('appUrlOpen',  (event) => {
	let path = event.url.replace(process.env.VUE_APP_URL, '');

	router.push(path);
});

export default router